import { Contact } from './contact';
export interface UpdateFuelSupplierContactRequest {
  fuelSupplierId: number;
  contacts: Contact[];
}
